import React from 'react';
import PropTypes from 'prop-types';
import MarketShare from 'components/partials/charts/ShareChart';
import {
  transformPieChartData,
  generateStationGroup,
  removeDuplicated
} from '../ProductionDashboardHelpers';

export default function ShiftsThroughputTab({ productionItems, ancillaryItems, hardwareItems }) {
  return (
    <div>
      <h3>Shifts Throughput</h3>
      <div className="charts-grid">
        {productionItems && productionItems.length > 0 &&
          productionItems.map((station, ind) => (
            <MarketShare
              key={ind}
              data={transformPieChartData(
                station.value,
                'shift',
                station.key
              )}
              radius={['95%', '83%']}
              title={generateStationGroup(station.key)}
              summary={
                station.key === 'sashAssembly'
                  ? removeDuplicated(station.value)?.length
                  : ''
              }
            />
          ))}
          
        {ancillaryItems && ancillaryItems.length > 0 && (
          <MarketShare
            data={transformPieChartData(
              ancillaryItems.filter(b => !b.isBox),
              'shift'
            )}
            radius={['95%', '83%']}
            title={'Ancillaries'}
          />
        )}
        
        {hardwareItems && hardwareItems.length > 0 && (
          <MarketShare
            data={transformPieChartData(
              hardwareItems.filter(b => !b.isBox),
              'shift'
            )}
            radius={['95%', '83%']}
            title={'Hardwares'}
          />
        )}
      </div>
    </div>
  );
}

ShiftsThroughputTab.propTypes = {
  productionItems: PropTypes.array.isRequired,
  ancillaryItems: PropTypes.array.isRequired,
  hardwareItems: PropTypes.array.isRequired
};
